import styles from './index.module.css'

import * as React from 'react'

import Logo from 'components/ui/logo'

const FooterLogo = ({
  link,
  onClick,
}: {
  link: string
  onClick?: () => void
}): React.ReactElement<'a'> => {
  return (
    <a
      href={link}
      rel="noopener"
      target="_blank"
      className={styles['FooterLogo']}
      onClick={onClick}
    >
      <Logo />
    </a>
  )
}

export default FooterLogo
